import CustomSelect from "../../../common/interactive/CustomSelect"
import { useDispatch, useSelector } from "react-redux"
import { returnOnlyPracticesThatAreOnTheCase } from "../../../../lib/misc"
import { documentsTypes, practicesOptions } from "../../../../lib/systemData"
import { useState } from "react"
import { updateDocumentApi, uploadDocumentApi } from "../../../../lib/fetchApi"
import { notificationActions } from "../../../../store/notifications"
import { caseActions } from "../../../../store/case"
import Button from "../../../common/Button"
import InputBox from "../../../common/interactive/InputBox"
import CustomSelectMultiple from "../../../common/interactive/CustomSelectMultiple"
import classes from './DocumentsTabListItemUploading.module.css'
import { validateBoxUploadFile } from "../../../../lib/docs"

export default function DocumentEditable({data, file, removeFile, isEditing, cancelEditFile}) {

    const documentTypeId = useSelector(state => state.documents.documentTypeId)
    const activeCase = useSelector(state => state.case.activeCase)
    const userToken = useSelector(state => state.user.token)
    const dispatch = useDispatch()


    let types = documentsTypes()
    let practices = practicesOptions()

    const [typeBySelect, setTypeBySelect] = useState(null)
    const [selectedDocumentTypeId, setSelectedDocumentTypeId] = useState(isEditing  ? isEditing.document_type_id : documentTypeId)
    const [selectedDocumentTypeWhole, setSelectedDocumentTypeWhole] = useState(types.find(item => item.value == documentTypeId))
    const [isLoading, setIsLoading] = useState(false)
    const [documentNotes, setDocumentNotes] = useState(isEditing  ? isEditing.notes : '')
    const [selectedPractices, setSelectedpractices] = useState([])
    const [practicesFilteredOptions, setPracticesFilteredOptions] = useState([])

    
    const documentTypeHandler = (value) => {
        setSelectedDocumentTypeId(value.data.value)
        setSelectedDocumentTypeWhole(value)
        setTypeBySelect(value.option.data.type)

        if (value.data.value == 1 && practicesFilteredOptions) {
            setPracticesFilteredOptions([...practicesFilteredOptions, {
                label: 'All',
                value: 'all'
            }])
        } else {
            if (activeCase && activeCase.practices && activeCase.practices.length > 0) {
                let items = returnOnlyPracticesThatAreOnTheCase(activeCase, practices)
                setPracticesFilteredOptions(items)
            }
        }
    }

    const changePracticesHandler = (value) => {
        setSelectedpractices(value.data.value)
    }

    const setNotesHandler = (value) => {
        setDocumentNotes(value.data.value ? value.data.value : '')
    }

    const saveFileHandler = async () => {
        setIsLoading(true)
        
        try {
            if (file) {
                const sizeError = validateBoxUploadFile(file.file_to_upload)
                if (sizeError) {
                    dispatch(notificationActions.setError({
                        errorMessage: `"${file.file}" is too large. ${sizeError}`,
                    }))
                    return
                }

                let formData = new FormData();

                formData.append("file", file.file_to_upload);
                formData.append("notes", documentNotes);
                formData.append("document_type_id", selectedDocumentTypeId)
                formData.append("practices", selectedPractices.join(','))

                let reqBody = formData

                const upload = await uploadDocumentApi(userToken, activeCase.case.id, reqBody, dispatch)  

                if (upload?.errorMessage) {
                    dispatch(notificationActions.setError(upload))
                } else {
                    // /success 
          
                    removeFile(data.id)               
                
                    // add item to store dispatch
                    dispatch(caseActions.pushItemToDDocuments(upload))
                }
            }
        } finally {
            setIsLoading(false)
        }
    }

    async function editFileHandler() {
        setIsLoading(true)
        try {
            let response = await updateDocumentApi(userToken, activeCase.case.id, data.id, {
                type: 'case_document',
                document_type_id: selectedDocumentTypeId,
                practices: typeBySelect !== 'Practice' ? null : selectedPractices.join(','),
                notes: documentNotes
            })

            if (response?.errorMessage) {
                dispatch(notificationActions.setError(response))
            } else {
                dispatch(caseActions.replaceWholeItemInDocuments(response))
            
                cancelEditFileHandler()
            }
        } finally {
            setIsLoading(false)
        }
    }

    const cancelEditFileHandler = () => {
        if (cancelEditFile) {
            cancelEditFile()
        }
    }

    return <>
    {/* ######## document type ######## */}
        <td>
            <CustomSelect optionsData={types} preSelectedValue={selectedDocumentTypeId} action={documentTypeHandler} sameSizeAsContainer={true}/>
        </td>
            
        {/* ######## practice --- this is available only if the type is practice ######## */}
        <td>   
            {typeBySelect == 'Practice' && practicesFilteredOptions && <>
                <CustomSelectMultiple optionsData={practicesFilteredOptions} preSelectedValue={selectedDocumentTypeId} action={changePracticesHandler} sameSizeAsContainer={true}/>
            </>}
            {typeBySelect !== 'Practice' && <>-</>} 
        </td>

        {/* ######## notes ######## */}
        <td className={classes.td_input}>
            <InputBox placeholder={'Write note here...'} action={setNotesHandler} currentValue={documentNotes} />
        </td>

         {/* ######## save document ######## */}
         <td>
            {!isEditing && <Button btnStyle={'btn_small'} color={'white'} click={saveFileHandler} isLoading={isLoading} isDisabled={!setSelectedDocumentTypeWhole}><i className='ti ti-check'></i>Save</Button>}
            {isEditing && <div className="flex-container">
                <Button btnStyle={'btn_small'} color={'white'} click={editFileHandler} isLoading={isLoading} isDisabled={!setSelectedDocumentTypeWhole}><i className='ti ti-device-floppy'></i></Button>
                <Button btnStyle={'btn_simple'} color={'danger'} click={cancelEditFileHandler} ><i className='ti ti-x'></i></Button>
            </div>}
        </td>
    </>
}